"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("..");
exports.createContentFeed = graphql_tag_1.default `
  mutation createContentFeed(
    $cmsId: ID!,
    $data: ContentFeedCreateInput!
  ) {
    createContentFeed(
      cmsId: $cmsId,
      data: $data
    ) {
      ...contentFeedDetailData
    }
  }
  ${graphql_1.contentFeedDetailData}
`;
exports.updateContentFeed = graphql_tag_1.default `
  mutation updateContentFeed(
    $id: ID!,
    $data: ContentFeedUpdateInput!
  ) {
    updateContentFeed(
      id: $id,
      data: $data
    ) {
      ...contentFeedDetailData
    }
  }
  ${graphql_1.contentFeedDetailData}
`;
exports.proxy = graphql_tag_1.default `
  mutation proxy(
    $contentFeedId: ID,
    $url: String,
    $responseType: String
  ) {
    proxy(
      contentFeedId: $contentFeedId,
      responseType: $responseType,
      url: $url
    ) {
      data
      status
      headers
    }
  }
`;
exports.archiveContentFeed = graphql_tag_1.default `
  mutation archiveContentFeed(
    $id: ID!,
    $archived: Boolean!
  ) {
    archiveContentFeed(
      id: $id,
      archived: $archived
    ) {
      archived
      id
    }
  }
`;
exports.deleteContentFeed = graphql_tag_1.default `
  mutation deleteContentFeed(
    $id: ID!
  ) {
    deleteContentFeed(
      id: $id
    )
  }
`;
exports.clearContentFeedPushedContent = graphql_tag_1.default `
  mutation clearContentFeedPushedContent(
    $id: ID!
  ) {
    clearContentFeedPushedContent(
      id: $id
    ) {
            ...contentFeedDetailData
    }
  }
  ${graphql_1.contentFeedDetailData}
`;
exports.generateNewContentFeedPushUrl = graphql_tag_1.default `
  mutation generateNewContentFeedPushUrl(
    $id: ID!
  ) {
    generateNewContentFeedPushUrl(
      id: $id
    ) {
      ...contentFeedDetailData
    }
  }
  ${graphql_1.contentFeedDetailData}
`;
exports.sendTestContentPush = graphql_tag_1.default `
  mutation sendTestContentPush(
    $id: ID!,
    $data: String!
  ) {
    sendTestContentPush(
      id: $id,
      data: $data
    )
  }
`;
//# sourceMappingURL=contentFeeds.js.map